import { connect } from 'react-redux'
import * as actions from '../LoggedIn/actions'
import { shouldRedirectUserToLogin } from '../../layouts/LoggedIn/actions'
import Layout from './Layout'

const mapStateToProps = (state, ownProps) => {
  return {
    redirectToLogin: state.loginLayout.redirectToLogin,
    tokenVerified: state.loginLayout.tokenVerified,
    isLoggedIn: state.login.isLoggedIn,
    open: state.loginLayout.open,
    ...ownProps
  }
}

const mapDispatchToProps = dispatch => ({
  returnUserIfUserExists: token =>
    dispatch(actions.returnUserIfUserExists(token)),
  checkValidity: token => dispatch(actions.checkValidity(token)),
  checkTokenOnPathChange: token =>
    dispatch(actions.checkTokenOnPathChange(token)),
  shouldRedirectUserToLogin: bool => dispatch(shouldRedirectUserToLogin(bool)),
})

const DomainLayoutContainer = connect(mapStateToProps, mapDispatchToProps)(
  Layout,
)

export default DomainLayoutContainer



// WEBPACK FOOTER //
// ./src/layouts/Domain/DomainLayoutContainer.js